<template>
    <div>
        <div
            class="mp-promos__productWrapper"
            :id="`mp-promos__productWrapper-${product.id}`"
        >
            <div class="c-tr">
                <div class="c-tw w-names">
                    <div v-if="product.main !== false" class="c-td c-promos-image py-0 pr-2">
                        <div class="c-fig c-fig--promos">
                            <img
                                v-if="imgPath"
                                :src="imgPath"
                                alt
                                class="c-fig__img"
                            />
                        </div>
                    </div>
                    <div class="c-td">
                        <p class="text-primary font-weight-medium mb-0">
                            {{ dictProduct.name }}
                        </p>
                        <p class="typo--sm mb-0">EAN: {{ product.ean || dictProduct.ean }}</p>
                    </div>
                </div>
                <div
                    v-if="promoType !== PROMO_TYPES.SALES_TARGET && product.main !== false"
                    class="c-tw w-numbers products-list-numbers"
                    :class="{
                        'c-tw w-data': isPromomix1,
                        'w-data': isPromomix
                    }"
                >
                    <!-- Zwrot netto -->
                    <div
                        v-if="!isBonded || (isBonded && !isSetTrigger(productSet))"
                        class="c-td c-cashback"
                    >
                        <span class="typo-label d-inline d-md-none d-md-none mr-2 mr-md-0">
                            Zwrot netto
                        </span>
                        <span
                            v-if="product.organizer_refund_amount"
                            class="d-block d-md-inline-block typo-number"
                        >
                            {{ product.organizer_refund_amount | currency(promoType) }}
                        </span>
                        <span
                            v-else
                            class="d-block d-md-inline-block typo-number"
                        >---</span>
                    </div>

                    <!-- Punkty / Min. liczba -->
                    <div
                        class="c-td"
                        v-if="
                            !isBonded &&
                                !isPromomix1 &&
                                promoType !== PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION &&
                                promoType !== PROMO_TYPES.WEIGHT_REGULAR_PRICE
                        "
                        :class="{ 'w-points': isPromomix }"
                    >
                        <span class="typo-label d-inline d-md-none">
                            {{ isPromomix ? 'Punkty' : 'Min. liczba' }}
                        </span>
                        <span class="d-block d-md-inline-block typo-number">
                            {{ minAmount }}
                        </span>
                    </div>

                    <!-- Cena hurtowa (max. marża) ECD-->
                    <div
                        v-if="
                            !isBonded &&
                                promoType !== PROMO_TYPES.QUOTA &&
                                promoType !== PROMO_TYPES.PROMO_ITEM_FIXED_PRICE
                        "
                        class="c-td"
                        :class="{ 'w-points': isPromomix }"
                    >
                        <span
                            class="typo-label d-flex align-items-start d-md-none flex-column"
                        >
                            <span>Max cena hurt. ECD</span>
                            <span class="d-flex align-items-center">
                                (marża %)
                                <a-icon
                                    icon="Info"
                                    width="1rem"
                                    height="1rem"
                                    class="text-dark ml-1"
                                    v-tooltip="wholesalePriceMarginTooltip('ECD')"
                                />
                            </span>
                        </span>
                        <span
                            class="
                                typo-number d-flex flex-column align-items-md-center align-items-end
                            "
                        >
                            <span v-if="product.wholesale_price_distribution">
                                {{ product.wholesale_price_distribution | currency(promoType) }}
                            </span>
                            <span v-else>b/d</span>
                            <span>
                                ({{
                                    $functions.calculateMargin({
                                        product,
                                        productSet,
                                        wholesaleType:
                                            'wholesale_price_distribution'
                                    })
                                }})
                            </span>
                        </span>
                    </div>

                    <!-- Cena hurtowa (max. marża) ECC-->
                    <div
                        v-if="
                            !isBonded &&
                                promoType !== PROMO_TYPES.QUOTA &&
                                promoType !== PROMO_TYPES.PROMO_ITEM_FIXED_PRICE
                        "
                        class="c-td"
                        :class="{ 'w-points': isPromomix }"
                    >
                        <span
                            class="typo-label d-flex align-items-start d-md-none flex-column"
                        >
                            <span>Max cena hurt. ECC</span>
                            <span class="d-flex align-items-center">
                                (marża %)
                                <a-icon
                                    icon="Info"
                                    width="1rem"
                                    height="1rem"
                                    class="text-dark ml-1"
                                    v-tooltip="wholesalePriceMarginTooltip('ECC')"
                                />
                            </span>
                        </span>
                        <span
                            class="
                                typo-number d-flex flex-column align-items-md-center align-items-end
                            "
                        >
                            <span v-if="product.wholesale_price_cash_and_carry">
                                {{ product.wholesale_price_cash_and_carry | currency(promoType) }}
                            </span>
                            <span v-else>b/d</span>
                            <span>
                                ({{
                                    $functions.calculateMargin({
                                        product,
                                        productSet,
                                        wholesaleType:
                                            'wholesale_price_cash_and_carry'
                                    })
                                }})
                            </span>
                        </span>
                    </div>

                    <!-- Cena hurtowa (max. marża) DZ-->
                    <div
                        v-if="
                            !isBonded &&
                                promoType !== PROMO_TYPES.QUOTA &&
                                promoType !== PROMO_TYPES.PROMO_ITEM_FIXED_PRICE
                        "
                        class="c-td"
                        :class="{ 'w-points': isPromomix }"
                    >
                        <span
                            class="typo-label d-flex align-items-start d-md-none flex-column"
                        >
                            <span>Max cena hurt. DZ</span>
                            <span class="d-flex align-items-center">
                                (marża %)
                                <a-icon
                                    icon="Info"
                                    width="1rem"
                                    height="1rem"
                                    class="text-dark ml-1"
                                    v-tooltip="wholesalePriceMarginTooltip('DZ')"
                                />
                            </span>
                        </span>
                        <span
                            class="typo-number d-flex flex-column align-items-md-center align-items-end"
                        >
                            <span v-if="product.wholesale_price_external_distribution">
                                {{
                                    product.wholesale_price_external_distribution
                                        | currency(promoType)
                                }}
                            </span>
                            <span v-else>b/d</span>
                            <span>
                                ({{
                                    $functions.calculateMargin({
                                        product,
                                        productSet,
                                        wholesaleType:
                                            'wholesale_price_external_distribution'
                                    })
                                }})
                            </span>
                        </span>
                    </div>

                    <div class="c-td" v-if="promoType === PROMO_TYPES.QUOTA">
                        <span class="typo-label d-inline d-md-none">Rabat brutto</span>
                        <span class="d-block d-md-inline-block typo-number">
                            {{ -product.discount_amount | currency }}
                        </span>
                    </div>

                    <div
                        class="c-td"
                        v-else-if="
                            product.maximum_price !== undefined &&
                                product.maximum_price !== null
                        "
                    >
                        <span class="typo-label d-inline d-md-none">Max. cena</span>
                        <span
                            v-if="product.maximum_price"
                            class="d-block d-md-inline-block typo-number"
                        >
                            {{ product.maximum_price | currency(promoType) }}
                        </span>
                        <span
                            v-else
                            class="d-block d-md-inline-block typo-number"
                        >---</span>
                    </div>
                </div>
            </div>
            <slot name="showMoreBtn"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import promoBonded from '@/mixins/promoBonded'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    data() {
        return {
            editPrice: false
        }
    },
    mixins: [promoBonded],
    props: {
        product: {
            type: Object,
            required: true
        },
        promotion: {
            type: Object,
            required: true
        },
        productSet: {
            type: Object,
            required: false
        }
    },
    created() {
        this.PROMO_TYPES = PROMO_TYPES
    },
    computed: {
        dictProduct() {
            return this.product.dict_product || {}
        },
        promoType() {
            return this.promotion.type
        },
        isPromomix() {
            return this.promoType.includes('Promo::Mix')
        },
        isPromomix1() {
            return this.promoType.includes('Promo::Mix1')
        },
        minAmount() {
            if (this.isPromomix) {
                return this.product.weight
            }

            return this.product.count || 1
        },
        imgPath() {
            return this.dictProduct.image?.urls?.small || ''
        }
    },
    methods: {
        wholesalePriceMarginTooltip(code) {
            return this.$store.getters.getWholesalePriceMarginTooltip(code)
        }
    }
}
</script>
